export const getVietnamToday = () => {
    const now = new Date();
    // Chuyển sang múi giờ Việt Nam (UTC+7)
    // Note: This logic in original code assumes client browser creates Date object. 
    // toLocaleString with timeZone doesn't change the Date object itself if passed to new Date() constructor directly correctly in all browsers, 
    // but let's stick to original logic: creating a date object that represents VN time components.
    const vietnamTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Ho_Chi_Minh' }));
    return vietnamTime;
};

export const getWeekNumber = (date: Date): number => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
};

export const periodValueToDate = (value: string, type: 'year' | 'month' | 'week' | 'day'): Date | null => {
    if (!value) return null;

    try {
        if (type === 'day') {
            const [year, month, day] = value.split('-').map(Number);
            return new Date(year, month - 1, day);
        } else if (type === 'month') {
            const [year, month] = value.split('-').map(Number);
            return new Date(year, month - 1, 1);
        } else if (type === 'week') {
            const [yearStr, weekStr] = value.split('-W');
            const year = parseInt(yearStr);
            const week = parseInt(weekStr);
            const jan1 = new Date(year, 0, 1);
            const daysOffset = (jan1.getDay() || 7) - 1;
            const targetDate = new Date(year, 0, 1 + (week - 1) * 7 - daysOffset);
            return targetDate;
        } else if (type === 'year') {
            return new Date(parseInt(value), 0, 1);
        }
    } catch (e) {
        return null;
    }
    return null;
};

export const dateToPeriodValue = (date: Date, type: 'year' | 'month' | 'week' | 'day'): string => {
    if (!date) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    if (type === 'day') {
        return `${year}-${month}-${day}`;
    } else if (type === 'month') {
        return `${year}-${month}`;
    } else if (type === 'week') {
        const week = getWeekNumber(date);
        return `${year}-W${String(week).padStart(2, '0')}`;
    } else if (type === 'year') {
        return year.toString();
    }
    return '';
};
